import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'Horas'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Seg'
  }];
  return <div className="rounded-xl border border-navy-100 bg-white px-4 py-4 shadow-card" data-id="element-88" data-mp="374mdib6ohp8n">
      <p className="flex items-center justify-center gap-2 text-[12px] font-bold uppercase tracking-[0.14em] text-navy-700" data-id="element-89" data-mp="10a8t04g7xrwc">
        <ClockIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-90" data-mp="y16i72aoprn0" />
        La oferta de lanzamiento termina en
      </p>
      <div className="mt-3 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-91" data-mp="t2vaax3y9r7f">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-92" data-mp="12rwochqxpyir" data-mpi={index}>
            <div className="flex min-w-[68px] flex-col items-center rounded-lg bg-navy-900 px-3 py-2" data-id="element-93" data-mp="12t7s4hkdr69v">
              <span className="font-sans text-2xl font-extrabold tabular-nums text-white sm:text-3xl" data-id="element-94" data-mp="f33typpynyq9">
                {block.value}
              </span>
              <span className="text-[10px] font-semibold uppercase tracking-widest text-navy-200" data-id="element-95" data-mp="o2quzaes32is">
                {block.label}
              </span>
            </div>
            {index < blocks.length - 1 && <span className="self-center text-xl font-bold text-navy-400" data-id="element-96" data-mp="1zhmfhd03vy79">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}